// Port of api/fuel/app/classes/model/log/user/hindex.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Model.extend({
	table: 'log_user_hindex',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		play_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		hindex_id: Model.SCHEMA_NUMBER,
		log_hindex: Model.SCHEMA_NUMBER,
		log_initial_sync: Model.SCHEMA_NUMBER,
		log_plays_level: Model.SCHEMA_NUMBER,
		log_plays_all: Model.SCHEMA_NUMBER,
		log_games_level: Model.SCHEMA_NUMBER,
		log_games_new: Model.SCHEMA_NUMBER,
		log_games_all: Model.SCHEMA_NUMBER,
		log_days: Model.SCHEMA_NUMBER,
		log_efficiency_current: Model.SCHEMA_NUMBER,
		log_efficiency_next: Model.SCHEMA_NUMBER,
		log_index_level: Model.SCHEMA_TEXT,
		log_index_played: Model.SCHEMA_TEXT
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_HINDEX },
		get_index_level: function() {
			return Util.parse_id_list(this._data.log_index_level)
		},
		get_index_played: function() {
			return Util.parse_id_list(this._data.log_index_played)
		},
		to_array: function() {
			return {
				id: +this.get_id(),
				user: +this.get_user_id(),
				date: +this.get_date(),
				type: +this.get_type(),
				hindextype: +this.get_hindex_id(),
				hindex: +this.get_hindex()
			}
		}
	}
})
